import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function MoreProducts(){
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('Más Productos');
  const api = baseURL;
  useEffect(()=>{ 
    fetch(`${api}/masProductosGet.php?t=${Date.now()}`, { cache:'no-store', headers:{ 'Accept':'application/json' } })
      .then(r=>r.text()).then(t=>{ try{ const d=JSON.parse(t); setItems(d.items||[]);}catch(_){ setItems([]);} }); 
    fetch(`${api}/masProductosConfigGet.php?t=${Date.now()}`, { cache:'no-store', headers:{ 'Accept':'application/json' } })
      .then(r=>r.text()).then(t=>{ try{ const d=JSON.parse(t); if(d && d.tituloPublico) setTitle(d.tituloPublico);}catch(_){ } });
  },[]);
  return (
    <div style={{ margin:'40px 0', padding:'0 16px' }}>
      <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
        {items.length>0 && (
          <h3 style={{ textAlign:'center', margin:'0 0 16px', fontSize:'clamp(1.2rem, 2.5vw, 1.6rem)' }}>{title}</h3>
        )}
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={16}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={true}
          className='moreproducts-swiper'
        >
          {items.map(it => (
            <SwiperSlide key={it.idMasProducto} style={{ width:'280px' }}>
              <a
                href={(it.url && (/^https?:|^mailto:|^tel:/i.test(it.url) ? it.url : `http://${it.url}`)) || '#'}
                style={{
                  textDecoration:'none', color:'inherit', display:'block', background:'#fff', border:'1px solid #eee',
                  borderRadius:'12px', padding:'10px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', transition:'transform .2s ease, box-shadow .2s ease'
                }}
                onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 6px 16px rgba(0,0,0,0.12)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.06)'; }}
              >
                {it.imagen && (
                  <img
                    loading="lazy"
                    decoding="async"
                    width="1200"
                    height="160"
                    src={/^https?:/i.test(it.imagen) ? it.imagen : `${api}/${String(it.imagen).replace(/^\//,'')}`}
                    alt={it.titulo}
                    style={{ width:'100%', height:'160px', objectFit:'contain', background:'#fff', borderRadius:'8px' }}
                  />
                )}
                <h4 style={{ margin:'10px 0 6px', fontSize:'1rem' }}>{it.titulo}</h4>
                {it.descripcion && (<p style={{ color:'#555', margin:'0 0 6px' }}>{it.descripcion}</p>)}
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
